// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611040407/js/" + chunkId + "." + {"44":"5e36ea12","225":"0deabcf7","481":"0941e1b8","486":"a216e761","770":"75a5027a"}[chunkId] + ".0.33460707995434646.chunk.js";
};